import { Box, Typography } from '@mui/material'
import i18n from 'i18n'
import { theme } from 'theme'

interface FloatingTitleProps {
  title: string
}

export default function FloatingTitle(props: FloatingTitleProps) {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: 'auto',
        top: -10,
        left: i18n.dir() === 'ltr' ? 12 : undefined,
        right: i18n.dir() === 'rtl' ? 12 : undefined,
        backgroundColor: theme.palette.background.paper,
        zIndex: 99999,
        paddingLeft: '4px',
        paddingRight: '4px'
      }}
    >
      <Typography fontSize={'12px'} fontFamily={'NotoSans'}>
        {props.title}
      </Typography>
    </Box>
  )
}
